import {
  AirbnbVerificationMethod,
  AirbnbFrictionType,
  AirbnbRedirectVerification,
  AirbnbEmailVerification,
  AirbnbPhoneVerification
} from '../airbnbAuthModel';

// tslint:disable-next-line:no-any
export default function(data: any): AirbnbVerificationMethod[] {
  const {airlockId, userId, accessToken, frictionData, linkRedirect} = data;

  if (!frictionData || !Array.isArray(frictionData)) {
    return [{airlockId, linkRedirect} as AirbnbRedirectVerification];
  }

  let codeVerificationMethods: AirbnbVerificationMethod[] = [];

  // tslint:disable-next-line:no-any
  frictionData.forEach((entry: any) => {
    const {friction, hintText, phoneNumbers} = entry;

    const base = {airlockId, userId, friction, accessToken};

    if (friction === String(AirbnbFrictionType.Email)) {
      codeVerificationMethods.push({hintText, ...base} as AirbnbEmailVerification);
    }

    if (friction === String(AirbnbFrictionType.Phone)) {
      // tslint:disable-next-line:no-any
      phoneNumbers.forEach((phone: any) => {
        const {id: phoneId, hintText: phoneHintText} = phone;
        codeVerificationMethods.push({
          phoneId,
          hintText: phoneHintText,
          ...base
        } as AirbnbPhoneVerification);
      });
    }
  });

  return codeVerificationMethods;
}



// WEBPACK FOOTER //
// ./src/models/airbnbAuthModel/utils/normalizeVerificationMethods.ts